import React, { useState } from 'react';
import { GOLD, DARK2 } from '../constants/theme';
import { IMGS } from '../constants/images';
import SecLabel from './ui/SecLabel';

const services = [
  { icon:'🍽️', title:'Wedding Catering',  desc:'Bespoke menus tailored to make your wedding day truly magical. From intimate ceremonies to grand receptions.', img:IMGS.services[0] },
  { icon:'🎪', title:'Corporate Events',   desc:'Professional catering for conferences, product launches, team lunches, and corporate galas.',                img:IMGS.services[1] },
  { icon:'🎂', title:'Private Parties',    desc:'Birthdays, anniversaries, and milestone celebrations crafted with personalised menus.',                       img:IMGS.services[2] },
  { icon:'🔥', title:'Live Stations',      desc:'Interactive live cooking stations — BBQ, pasta, chaat, and more.',                                            img:IMGS.services[3] },
  { icon:'🍷', title:'Cocktail Events',    desc:'Elegant cocktail receptions with curated beverages, canapés, and sophisticated ambiance.',                     img:IMGS.services[4] },
  { icon:'🌿', title:'Outdoor Catering',   desc:'Full-service outdoor setups for garden parties, destination events, and open-air celebrations.',               img:IMGS.services[5] },
];

const Services: React.FC = () => {
  const [svcHov, setSvcHov] = useState<number | null>(null);
  return (
    <section id="live" style={{ background:DARK2, padding:'90px 8vw' }}>
      <SecLabel text="WHAT WE OFFER"/>
      <h2 style={{ fontFamily:'Cormorant Garamond', fontSize:'clamp(28px,3.6vw,48px)', fontWeight:300, color:'#fff', textAlign:'center', marginTop:6 }}>
        We Offer <em style={{ color:GOLD }}>Top Notch</em> Services
      </h2>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(260px,1fr))', gap:3, marginTop:44 }}>
        {services.map((s,i) => (
          <div key={s.title} style={{ position:'relative', overflow:'hidden', cursor:'default' }}
            onMouseEnter={() => setSvcHov(i)} onMouseLeave={() => setSvcHov(null)}>
            <img src={s.img} alt={s.title} style={{ width:'100%', height:200, objectFit:'cover', filter:'brightness(0.35)', transform:svcHov===i?'scale(1.05)':'scale(1)', transition:'all 0.5s' }}/>
            <div style={{ position:'absolute', inset:0, background:svcHov===i?'rgba(0,0,0,0.55)':'rgba(0,0,0,0.3)', border:`1px solid ${svcHov===i?'rgba(196,152,50,0.4)':'rgba(255,255,255,0.04)'}`, transition:'all 0.4s', padding:'32px 28px', display:'flex', flexDirection:'column', justifyContent:'flex-end' }}>
              <div style={{ fontSize:28, marginBottom:10 }}>{s.icon}</div>
              <div style={{ width:30, height:1, background:GOLD, marginBottom:12 }}/>
              <h3 style={{ fontFamily:'Cormorant Garamond', fontSize:19, fontWeight:500, color:GOLD, marginBottom:10 }}>{s.title}</h3>
              <p style={{ fontFamily:'Montserrat', fontSize:11, color:'rgba(255,255,255,0.7)', lineHeight:1.8 }}>{s.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;